import {Outlet, useNavigate} from 'react-router-dom';
import {Suspense} from 'react';
import {signInWithRedirect} from 'aws-amplify/auth';
import {
    FlexiSignInButton,
    PlatformAppShell,
    PlatformFooter,
    PlatformHeader,
    PlatformHeaderNavigationMenu,
    PlatformHeaderToolbar,
    PlatformLoader,
} from '@flexinet/ui-components';

// Unauthenticated shell. Header with nav menu + sign-in button; no
// sidebar (navbar width=0). The sign-in button kicks off Cognito hosted-UI
// via `signInWithRedirect()`. Apps add public marketing routes (Home,
// About, Pricing, etc.) under the same routesConfig parent.
export const PublicLayout = () => {
    const navigate = useNavigate();

    const menuItems = [
        {title: 'Home', onClick: () => navigate('/')},
    ];

    const toolbar = (
        <PlatformHeaderToolbar
            additionalToolbarItems={[
                <FlexiSignInButton key="sign-in" onClick={() => signInWithRedirect()}>
                    Sign in
                </FlexiSignInButton>,
            ]}
        />
    );

    const header = (
        <PlatformHeader
            navigationMenu={<PlatformHeaderNavigationMenu menuItems={menuItems} />}
            toolbar={toolbar}
        />
    );

    return (
        <PlatformAppShell
            platformHeader={header}
            platformFooter={<PlatformFooter />}
            header={{height: 80}}
            footer={{height: 100}}
            navbar={{width: 0, breakpoint: 'sm'}}
        >
            <Suspense fallback={<PlatformLoader />}>
                <Outlet />
            </Suspense>
        </PlatformAppShell>
    );
};
